import React from 'react';
import close from '@/public/assets/close.png';
import close2x from '@/public/assets/close@2x.png';
import close3x from '@/public/assets/close@3x.png';
import ImgIcon from '../BaseIcon';

const Close = () => (
    <ImgIcon
        srcset={`${close},
                ${close2x} 2x,
                ${close3x} 3x,`}
        src={close3x}
        alt="close"
    />
);

export default Close;
